var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-scrollbar',{staticClass:"build views"},[_c('container',{ref:"container",attrs:{"props":_vm.props,"option":_vm.option}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }